import { CourierDto, KnownSortOrder } from '@groundfloor-platform/mgmt-service-g-sdk';
import { useCallback } from 'react';
import { createPath, Paths, ProjectPathParams } from '../../../../app/router/app.router';
import {
  InfiniteScrollProps,
  InfiniteTable,
  PaginatedRow
} from '../../../../ui/components/pure/list-table-wrappers/infinite-table.component';
import { CouriersListControlsState } from '../logic/couriers-list-query.map';
import { CourierColumn, CourierRowAction, useCouriersTable } from '../hooks/use-couriers-table.hook';

type CouriersTableProps = {
  params: ProjectPathParams<Paths.couriers>;
  pages: PaginatedRow<CourierDto>[];
  infiniteScroll: InfiniteScrollProps;
  setFormData: (update: Partial<CouriersListControlsState>) => void;
  sortData: { sortBy: string; sortOrder: KnownSortOrder };
  isLoading: boolean;
  isPreviousData: boolean;
  hasError: boolean;
  customMessage?: string;
  hiddenColumns?: CourierColumn[];
  rowAction?: CourierRowAction;
};

export function CouriersTable({
  params,
  pages,
  infiniteScroll,
  setFormData,
  sortData,
  isLoading,
  isPreviousData,
  hasError,
  customMessage,
  hiddenColumns,
  rowAction
}: CouriersTableProps) {
  const tb = useCouriersTable({ hiddenColumns, rowAction });

  // The viewer's project, not the courier's — theirs administers the carrier and may not be readable.
  const mapRowURL = useCallback(
    (row: CourierDto) =>
      createPath(Paths.courier, {
        projectID: params.shortcode || params.projectID,
        courierID: row.id
      }),
    [params.projectID, params.shortcode]
  );
  tb.config({ mapRowURL });

  return (
    <InfiniteTable
      uniqueKey="id"
      onSort={setFormData}
      sortData={sortData}
      table={tb}
      pages={pages}
      infiniteScroll={infiniteScroll}
      isLoading={isLoading}
      isPreviousData={isPreviousData}
      hasError={hasError}
      customMessage={customMessage}
    />
  );
}
